import LinearChartIcon from './component'

export default LinearChartIcon
